import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import studygameActions from '../../store/actions/studygameActions'
import Loading from '../Loading'
import Button from '../Button'
import NewsGame from './NewsGame'
import GameButtons from './GameButtons'

function shuffle2(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}

function shuffle(word) {
    var changeWord = word.split(""),
        changeWordTagged = word.split(""),
        wordLength = changeWord.length

    for (var i = 2; i <= wordLength - 1; i++) {
        function getRandomInt(max) {
            return Math.floor(Math.random() * Math.floor(max));
        }

        var tmp, tmpTagged
        let probability = getRandomInt(2)

        if ((probability === 0 && i >= 2) || (probability === 0 && i <= wordLength.length - 3)) {
            let update = i
            let min = Math.ceil(update)
            let max = update === wordLength - 2 ? Math.floor(update) : Math.floor(update + 3)
            var j = Math.floor(Math.random() * (max - min)) + min

            if (changeWordTagged[j]) {
                if (!changeWordTagged[j].includes('span')) {
                    if (changeWordTagged[i] !== changeWordTagged[j]) {
                        tmp = changeWord[i]
                        changeWord[i] = changeWord[j]
                        changeWord[j] = tmp

                        tmpTagged = `<span class='scrambledLetter'>${changeWordTagged[i]}</span>`
                        changeWordTagged[i] = `<span class='scrambledLetter'>${changeWordTagged[j]}</span>`
                        changeWordTagged[j] = tmpTagged
                    }
                }
            }
        }
    }
    return [changeWord.join(""), changeWordTagged.join("")]
}

const ReorderWord = ({ news }) => {
    const [state, setState] = useState({
        isLoading: true,
        titleCorrect: news.title,
        scrambledCharacters: null,
        inputContent: '',
        inputContentIndexes: []
    })

    useEffect(() => {
        const titleWords = news.title.split(" ");
        let longerWord = []
        let returnScrambledCharacters = []
        //let returnScrambledCharacters2 = []
        let returnScrambledString = ''
        let returnScrambledString2 = ''

        for (let item of titleWords) {
            // eslint-disable-next-line
            let filteredString = item.replace(/[`~!@#$%^"&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/gi, '')
            if (longerWord.length === 0 || longerWord[longerWord.length - 1].length < filteredString.length) {
                longerWord.push(filteredString)
            }
        }

        let getShuffle = shuffle(longerWord[longerWord.length - 1])

        returnScrambledString = getShuffle[1]

        for (let item of getShuffle[0]) {
            returnScrambledCharacters.push({ character: item, disabled: false })
        }

        returnScrambledString2 = `<span class='scrambledWord'>${returnScrambledString}</span>`

        const checkScrambledWord = (scrambledWord, correctWord) => {

            const noSpanString = scrambledWord.replace(/<\/?span[^>]*>/g, "")

            if (noSpanString === correctWord) {

                let newScrambledWord = shuffle(longerWord[longerWord.length - 1])
                let newScrambledWordSpan = `<span class='scrambledWord'>${newScrambledWord[1]}</span>`

                const newScrambler = () => {
                    while (newScrambledWord === correctWord) {
                        let newScrambledWord = shuffle(longerWord[longerWord.length - 1])
                        let newScrambledWordSpan = `<span class='scrambledWord'>${newScrambledWord[1]}</span>`
                    }
                    return newScrambledWordSpan
                }

                setState({
                    ...state,
                    isLoading: false,
                    word: longerWord[longerWord.length - 1],
                    scrambledCharacters: shuffle2(returnScrambledCharacters),
                    scrambledString: newScrambler
                })

            } else {
                setState({
                    ...state,
                    isLoading: false,
                    word: longerWord[longerWord.length - 1],
                    scrambledCharacters: shuffle2(returnScrambledCharacters),
                    scrambledString: returnScrambledString2
                })
            }
        }

        checkScrambledWord(returnScrambledString, longerWord[longerWord.length - 1])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const pressCharacter = (sentCharacter, sentIndex) => {
        state.scrambledCharacters[sentIndex].disabled = true
        let updateInputContent = state.inputContent.concat(sentCharacter)
        setState({ ...state, inputContent: updateInputContent, inputContentIndexes: state.inputContentIndexes.concat(sentIndex) })
        setTimeout(() => {
            if (state.word === state.inputContent.concat(sentCharacter)) {
                dispatch(studygameActions.finishMinigame())
            }
        }, 1000)
    }

    const deleteCharacter = () => {
        let length = state.inputContentIndexes.length
        let lastIndex = state.inputContentIndexes[length - 1]
        state.scrambledCharacters[lastIndex].disabled = false
        state.inputContentIndexes.pop()
        setState({ ...state, inputContent: state.inputContent.slice(0, -1), inputContentIndexes: length === 1 ? [] : state.inputContentIndexes })
    }

    const cleanInput = () => {
        for (let item of state.scrambledCharacters) {
            if (item.disabled) {
                item.disabled = false;
            }
        }
        setState({ ...state, inputContent: '', inputContentIndexes: [] })
    }

    const dispatch = useDispatch()

    const { word, scrambledString, inputContent } = state

    const changeNews = {
        ...news,
        title: news.title.replace(word, scrambledString)
    }

    const studyGameState = useSelector(state => state.studyGame)
    const { currentRound } = studyGameState
    const rightWord = inputContent

    //console.log(rightWord.length);
    //console.log(state.word.length)

    return (
        state.isLoading ? <Loading /> :
            <article className='white-container mb-4'>
                <NewsGame round={currentRound} news={changeNews} gameTitle='Ordene corretamente a palavra destacada no título!' gameTip={<span>Dica: Somente as letras a <span className="tip">vermelho</span> estão fora de sítio na palavra.</span>} />
                <div className='py-8 lg:py-10'>
                    <div className='flex flex-wrap lg:flex-no-wrap grid-rows-2 lg:grid-rows-1 grid-cols-1 pb-6'>
                        <div className='w-full lg:w-8/12'>
                            <input
                                disabled={true}
                                placeholder='Clique nos botões em baixo para reordenar a palavra completa'
                                className={`shadow border rounded w-full mb-4 py-2 px-3 my-0 ${(rightWord === state.word) ? "rightWord" : (rightWord !== state.word && rightWord.length < state.word.length) ? "" : 'wrongWord'}`}
                                value={state.inputContent}
                            />
                        </div>
                        <div className='w-full grid-cols-1 lg:w-4/12'>
                            <Button
                                className='sm:mb-0 mr-0 float-right'
                                disabled={!state.inputContent ? true : false}
                                onClick={cleanInput}
                            >
                                Apagar tudo
                            </Button>
                            <Button
                                className='mr-3 sm:mb-0 float-right'
                                disabled={!state.inputContent ? true : false}
                                onClick={() => !state.inputContent ? null : deleteCharacter()}
                            >
                                Apagar letra
                            </Button>
                        </div>
                    </div>
                    <div className='grid gap-3 grid-cols-2 sm:grid-cols-4 md:grid-cols-6'>
                        {state.scrambledCharacters.map((item, index) => (
                            <Button
                                key={index}
                                disabled={item.disabled ? true : false}
                                onClick={() => { pressCharacter(item.character, index) }}
                                className='text-center justify-center minigameButton mr-0'

                            >
                                {item.character}
                            </Button>
                        ))}
                    </div>
                </div>
                <GameButtons />
            </article>
    )
}

export default ReorderWord